import React from 'react'
import { Link } from 'react-router-dom'
import { Menu as UikitMenu } from 'uikit'
import { useWeb3React } from '@web3-react/core'
import { languageList } from 'config/localization/languages'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import useAuth from 'hooks/useAuth'
import { usePriceDmdUsdc } from 'state/hooks'
import config from './config'
import footerLinks from './footerConfig'

const Menu = (props) => {
  const { account } = useWeb3React()
  const { login, logout } = useAuth()
  const { isDark, toggleTheme } = useTheme()
  const dmdPriceUsd = usePriceDmdUsdc()
  const { currentLanguage, setLanguage, t } = useTranslation()

  return (
    <UikitMenu
      linkComponent={({ href, ...linkProps }) => {
        const isHttpLink = href?.startsWith('http')
        const Tag: any = isHttpLink ? 'a' : Link
        const prop = isHttpLink ? { href, target: '_blank' } : { to: href }
        return <Tag {...prop} {...linkProps} />
      }}
      account={account}
      login={login}
      logout={logout}
      isDark={isDark}
      toggleTheme={toggleTheme}
      currentLang={currentLanguage.code}
      langs={languageList}
      setLang={setLanguage}
      dmdPriceUsd={dmdPriceUsd.toNumber()}
      links={config(t)}
      footerLinks={footerLinks(t)}
      {...props}
    />
  )
}

export default Menu
